export type PaywallWarnError = {
  "code": string,
  message: string,
  "data": {
    "maxObjectsCount": number ,
    "formattedAmount": string ,
    "MAX_LINE_SEGMENTS_COUNT": number ,
    "enableSegments": boolean,
    "objectCount": number ,
    "totalCount": number ,
    "warningObjectsCount1": number,
    "warningObjectsCount2": number,
  }
}

export type responseConfig = {
  "data": any,
  "success": boolean,
  "warning": PaywallWarnError,
  "error": PaywallWarnError
}

/**
 * 1 arg - code name
 * 2 arg - message
 */

export const paywallMessages = new Map<string, string>(
  [
    ['warning_objects_count_1', "You’re [WARNING_COUNT] objects away from reaching the [WARNING_MAX_COUNT]-object free limit. Our subscription plans offer more features and now start from just [FORMATTED_AMOUNT] per month!"],
    ['warning_objects_total_count_1', "You’re [WARNING_COUNT] objects away from reaching the [WARNING_MAX_COUNT]-object free limit. Our subscription plans offer more features and now start from just [FORMATTED_AMOUNT] per month!"],
    ['warning_objects_count_2', "You've reached the [WARNING_MAX_COUNT]-object free limit. Choose a subscription that suits your planning needs, including our new [FORMATTED_AMOUNT] Starter plan!"],
    ['warning_objects_total_count_2', "You've reached the [WARNING_MAX_COUNT]-object free limit. Choose a subscription that suits your planning needs, including our new [FORMATTED_AMOUNT] Starter plan!"],
    ['error_objects_count', "You've reached the [ERROR_MAX_COUNT]-object free limit. Choose a subscription that suits your planning needs, including our new [FORMATTED_AMOUNT] Starter plan!"],
    ['error_objects_total_count', "You've reached the [ERROR_MAX_COUNT]-object free limit. Choose a subscription that suits your planning needs, including our new [FORMATTED_AMOUNT] Starter plan!"],
  ]
);
